import React from 'react';
import { useAccessibility } from '../context/AccessibilityContext';
import { Link } from 'react-router-dom';

/**
 * Links — lien applicatif. Ajoute une surbrillance accessible quand l'option
 * "mettre les liens en surbrillance" est activée dans le module d'accessibilité.
 */
const Links = ({ to, children, className = '', ...props }) => {
  const { highlightLinks } = useAccessibility();
  const cls = `${className} ${highlightLinks ? 'link-highlight' : ''}`.trim();

  return (
    <Link to={to} className={cls} {...props}>
      {children}
    </Link>
  );
};

export default Links;
